import { render } from "./Overlay.vue?vue&type=template&id=66f62c6a&scoped=true&ts=true"
import script from "./Overlay.vue?vue&type=script&lang=ts"
export * from "./Overlay.vue?vue&type=script&lang=ts"

import "./Overlay.vue?vue&type=style&index=0&id=66f62c6a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f62c6a"]])

export default __exports__